(ns nl.mediquest.ui.component
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-event-db
 ::register
 (fn [db [_ component-key opts]]
   (assoc-in db [:nl.mediquest.lib/db :component component-key] opts)))

(re-frame/reg-event-db
 ::put
 (fn [db [_ component-key k v]]
   (assoc-in db [:nl.mediquest.lib/db :component component-key k] v)))

(re-frame/reg-sub
 ::state
 (fn [db [_ component-key]]
   (get-in db [:nl.mediquest.lib/db :component component-key])))

(defn register [component-key opts]
  (re-frame/dispatch [::register component-key opts]))

(defn put [component-key k v]
  (re-frame/dispatch [::put component-key k v]))

(defn state [component-key]
  (re-frame/subscribe [::state component-key]))

(defn render-components
  ([components] (render-components components {} nil))
  ([components context params]
   (doall
    (map-indexed
     (fn [id component]
       ^{:key id}
       [component context params])
     (sort-by (comp :component/position meta) components)))))
